// Purchase Order (Đơn mua xe VinFast từ NPP) constants.
// Sync với BE enum:
//   - PO_STATUS         backend/src/common/enum/purchase-order.enum.ts
//   - PO_PAYMENT_METHOD backend/src/common/enum/purchase-order.enum.ts
//
// LƯU Ý: KHÔNG nhầm với module legacy "Phiếu yêu cầu nhập hàng"
// (src/view/pages/purchase-orders/, permission PO_*). Module này là
// "Đơn mua xe" (mua xe VinFast từ Nhà phân phối), permission PURCHASE_ORDER_*,
// BE resource REST = `purchase-orders`.

export const PO_STATUS = {
  DRAFT: 'DRAFT',
  APPROVED: 'APPROVED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
};

export const PO_STATUS_LABEL = {
  [PO_STATUS.DRAFT]: 'Nháp',
  [PO_STATUS.APPROVED]: 'Đã duyệt',
  [PO_STATUS.COMPLETED]: 'Hoàn tất',
  [PO_STATUS.CANCELLED]: 'Đã hủy',
};

// BootstrapVue b-badge variant — dùng cho list/table.
export const PO_STATUS_VARIANT = {
  [PO_STATUS.DRAFT]: 'secondary',
  [PO_STATUS.APPROVED]: 'primary',
  [PO_STATUS.COMPLETED]: 'success',
  [PO_STATUS.CANCELLED]: 'danger',
};

// Icon FontAwesome theo status (badge ở row). Khi đổi màu icon nhớ
// `color: inherit !important` ở SCSS (frontend-styling rule #1).
export const PO_STATUS_ICON = {
  [PO_STATUS.DRAFT]: 'fas fa-pen',
  [PO_STATUS.APPROVED]: 'fas fa-check-circle',
  [PO_STATUS.COMPLETED]: 'fas fa-flag-checkered',
  [PO_STATUS.CANCELLED]: 'fas fa-ban',
};

// Soft bg + text color cho status pill (Metronic palette).
export const PO_STATUS_PILL = {
  [PO_STATUS.DRAFT]: { bg: '#E4E6EF', color: '#3F4254' },
  [PO_STATUS.APPROVED]: { bg: '#E1E9FF', color: '#3699FF' },
  [PO_STATUS.COMPLETED]: { bg: '#C9F7F5', color: '#1BC5BD' },
  [PO_STATUS.CANCELLED]: { bg: '#FFE2E5', color: '#F64E60' },
};

// Options dropdown filter (b-form-select dạng { value, text }).
export const PO_STATUS_OPTIONS = Object.values(PO_STATUS).map((v) => ({
  value: v,
  text: PO_STATUS_LABEL[v] || v,
}));

// Hình thức thanh toán — sync PO_PAYMENT_METHOD (BE enum).
export const PO_PAYMENT_METHOD = {
  CASH: 'CASH',
  FINANCIAL_GUARANTEE: 'FINANCIAL_GUARANTEE',
  UNBLOCKING_DISBURSEMENT: 'UNBLOCKING_DISBURSEMENT',
  DEFERRED_LIABILITY: 'DEFERRED_LIABILITY',
};

export const PO_PAYMENT_METHOD_LABEL = {
  [PO_PAYMENT_METHOD.CASH]: 'Trả thẳng',
  [PO_PAYMENT_METHOD.FINANCIAL_GUARANTEE]: 'Bảo lãnh thanh toán',
  [PO_PAYMENT_METHOD.UNBLOCKING_DISBURSEMENT]: 'Giải ngân phong tỏa',
  [PO_PAYMENT_METHOD.DEFERRED_LIABILITY]: 'Công nợ trả sau',
};

export const PO_PAYMENT_METHOD_OPTIONS = Object.values(PO_PAYMENT_METHOD).map(
  (v) => ({ value: v, text: PO_PAYMENT_METHOD_LABEL[v] || v }),
);

// Trạng thái xe ảo (sync PRODUCT_CHASSIS_SERIES_STATUS) — dùng cho
// label ở pipeline "Hàng đang về".
export const PO_CHASSIS_STATUS_LABEL = {
  PO_ORDERED: 'Đã đặt (chưa nhập kho)',
  ON_HOLDING_PENDING_IMPORT: 'Đã ghép - chờ về kho',
  PENDING_RECEIPT: 'Chờ xác nhận',
  NEW: 'Đã nhập kho',
  ON_HOLDING: 'Giữ hàng (đã về kho)',
};

// BootstrapVue b-badge variant theo trạng thái chassis.
export const PO_CHASSIS_STATUS_VARIANT = {
  PO_ORDERED: 'secondary',
  ON_HOLDING_PENDING_IMPORT: 'warning',
  PENDING_RECEIPT: 'warning',
  NEW: 'success',
  ON_HOLDING: 'info',
};

// Trạng thái 1 dòng preview import Excel — BE STATUS enum (số).
export const PO_IMPORT_ROW_STATUS = {
  SUCCESS: 1,
  ERROR: 0,
};
